import { InjectionToken } from '@angular/core';

export const AVAILABLE_DAY_RANGES = new InjectionToken<number[]>('AVAILABLE_DAY_RANGES');

export const DATEPICKER_MAX_DATE = new InjectionToken<Date>('DATEPICKER_MAX_DATE');
export const DATEPICKER_MIN_DATE = new InjectionToken<Date>('DATEPICKER_MIN_DATE');

/**
 * When provided, the picker operates in "fixed range" mode:
 * the user selects only a start date and the end date is
 * automatically set to start + fixedRangeDays − 1.
 * Dates whose computed range would exceed maxDate are disabled.
 */
export const DATEPICKER_FIXED_RANGE_DAYS = new InjectionToken<number>('DATEPICKER_FIXED_RANGE_DAYS');

export interface MonthlyDateRangePickerTexts {
    applySelectedMonthsText?: string;
    showFixedRangeDaysInStartPrompt?: boolean;
}

export const DATEPICKER_TEXTS = new InjectionToken<MonthlyDateRangePickerTexts>('DATEPICKER_MIN_DATE');
